var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.002 20C15.5248 20 20.002 15.5228 20.002 10C20.002 4.47715 15.5248 0 10.002 0C4.47911 0 0.00195312 4.47715 0.00195312 10C0.00195312 15.5228 4.47911 20 10.002 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56738 10H20.0021C20.0021 9.09743 19.8818 8.22305 19.6577 7.3913H9.56738V10Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56738 4.78211H18.5344C17.9223 3.78321 17.1396 2.90028 16.227 2.1734H9.56738V4.78211Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0022 20C12.3557 20 14.5188 19.1866 16.227 17.8261H3.77734C5.48555 19.1866 7.64871 20 10.0022 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46992 15.2166H18.5345C19.0259 14.4147 19.407 13.5381 19.6577 12.6079H0.34668C0.597344 13.5381 0.978477 14.4147 1.46992 15.2166Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63414 1.56164H5.54543L4.69777 2.17746L5.02156 3.17391L4.17395 2.55809L3.32633 3.17391L3.60602 2.31309C2.85969 2.93477 2.20555 3.66313 1.66648 4.47469H1.95848L1.41891 4.86668C1.33484 5.00691 1.25422 5.14937 1.17695 5.29395L1.43461 6.08695L0.953906 5.7377C0.834414 5.99086 0.725117 6.24973 0.626875 6.51398L0.910742 7.38773H1.95848L1.11082 8.00356L1.43461 9L0.586992 8.38418L0.0792578 8.75309C0.0284375 9.1616 0.00195312 9.57769 0.00195312 10H10.002C10.002 4.47719 10.002 3.82609 10.002 0C8.02648 0 6.18496 0.573047 4.63414 1.56164ZM5.02156 9L4.17395 8.38418L3.32633 9L3.65012 8.00356L2.80246 7.38773H3.8502L4.17395 6.39129L4.4977 7.38773H5.54543L4.69777 8.00356L5.02156 9ZM4.69777 5.09051L5.02156 6.08695L4.17395 5.47113L3.32633 6.08695L3.65012 5.09051L2.80246 4.47469H3.8502L4.17395 3.47824L4.4977 4.47469H5.54543L4.69777 5.09051ZM8.60852 9L7.7609 8.38418L6.91328 9L7.23707 8.00356L6.38941 7.38773H7.43715L7.7609 6.39129L8.08465 7.38773H9.13238L8.28473 8.00356L8.60852 9ZM8.28473 5.09051L8.60852 6.08695L7.7609 5.47113L6.91328 6.08695L7.23707 5.09051L6.38941 4.47469H7.43715L7.7609 3.47824L8.08465 4.47469H9.13238L8.28473 5.09051ZM8.28473 2.17746L8.60852 3.17391L7.7609 2.55809L6.91328 3.17391L7.23707 2.17746L6.38941 1.56164H7.43715L7.7609 0.565195L8.08465 1.56164H9.13238L8.28473 2.17746Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.ac75d64554007f416ab00627400d3028.svg";
export { ForwardRef as ReactComponent };